import React, { FC, ReactNode } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { classNames } from '@dt/fe-utils'
import { IonModal, IonContent, IonHeader, IonFooter } from '@ionic/react'
import { modalLayer } from '@utils'
import './index.scss'

// interface
export interface IProps {
  className?: string;
  title?: ReactNode |string;
  canClose?: boolean;
  confirmText?: ReactNode;
  // icon?: ""
  children?: ReactNode;
  cancelText?: ReactNode;
  isLight?: boolean;
  reject?: any;
  resolve?: any;
  backdropDismiss?: boolean;
  hasFooter?: boolean;
}

// TODO 需要统一为layer控制器调用的方式
const ConfirmModal: FC<IProps> = (props) => {
  const { children, className, title = '', confirmText = i18n.t('common.ok'), cancelText, isLight, canClose, reject, resolve, backdropDismiss = true, hasFooter = true } = props

  const handleConfirm = function () {
    resolve && resolve()
    modalLayer.resolve()
  }
  return (
    <IonModal
      isOpen
      backdropDismiss={backdropDismiss}
      cssClass={classNames('confirm-modal', className)}
    >
      <IonHeader>
        <div className='modal-title'>{title}</div>
        {
          !!canClose && (
            <i
              className='iconfont icon-close' data-cypid='confirmModalClose' onClick={() => {
                reject && reject(false)
                modalLayer.reject(false)
              }}
            >
            </i>
          )
        }
      </IonHeader>
      <IonContent>
        <div className='ion-content-wrap'>
          {
            children
          }
        </div>
      </IonContent>
      {hasFooter && (
        <IonFooter>
          {
            cancelText ? (
              <div className='footer-btn'>
                <div
                  className='cancel'
                  data-cypid='confirmModalCancel'
                  onClick={() => modalLayer.reject(true)}
                >{cancelText}
                </div>
                <div
                  data-cypid='confirmModalConfirm'
                  onClick={handleConfirm}
                  className='confirm'
                >{confirmText}
                </div>
              </div>
            ) : (
              <div
                data-cypid='confirmModalConfirm'
                className='footer-btn'
                onClick={handleConfirm}
              >
                <div className={isLight ? 'confirm' : 'cancel'}>{confirmText}</div>
              </div>
            )
          }
        </IonFooter>
      )}
    </IonModal>
  )
}

export default observer(ConfirmModal)
